const initialState = {
  baseUrl: ''
};

const baseUrlReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'SET_BASE_URL':
          return { ...state, baseUrl: action.payload };
      default:
          return state;
  }
};

export default baseUrlReducer;
